import React from 'react';
import logoTransferIsOk from '../img/newlogo.png';

/**
 * Página de bienvenida que se muestra después de que el usuario realiza el pago de la suscripción
 * Esta página informa al usuario que revise su correo electrónico para acceder a su cuenta
 */
function Bienvenida() {
    return (
        <div className="login-container" style={{
            backgroundColor: '#001c4d',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div className="login-card" style={{
                backgroundColor: 'white',
                borderRadius: '10px',
                padding: '30px',
                maxWidth: '500px',
                width: '90%',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
            }}>
                <div className="login-logo" style={{
                    textAlign: 'center',
                    marginBottom: '30px'
                }}>
                    <img
                        src={logoTransferIsOk}
                        alt="TransferisOK Logo"
                        style={{
                            maxWidth: '250px',
                            width: '100%'
                        }}
                    />
                </div>

                <h2 style={{
                    textAlign: 'center',
                    color: '#001c4d',
                    fontSize: '30px',
                    marginBottom: '30px'
                }}>¡Gracias por registrarte en TransferisOK!</h2>

                <div className="success-message" style={{
                    backgroundColor: '#e8f5e9',
                    padding: '20px',
                    borderRadius: '5px',
                    textAlign: 'center',
                    fontSize: '20px',
                    lineHeight: '1.6'
                }}>
                    <p>Revisa tu casilla de email para acceder a tu cuenta.</p>
                    <p>Puedes cerrar esta página.</p>
                </div>
            </div>
        </div>
    );
}

export default Bienvenida; 